module.exports = __webpack_public_path__ + "static/media/logo.37dc3f3e.svg";